import { FC } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import CommonWrapper from '../components/ui_components/CommonComponentsStructureCss';
import MainContainer from '../components/ui_components/MainContainer';
import colors from '../styles/colors';

interface Winner {
    id: number;
    name: string;
    avatar_path?: string;
}

interface SingleWinInfo {
    date_win: string;
    ppv_id: number;
    ppv_name: string;
    ppv_img_path?: string;
    winners: Winner[];
}

interface BeltData {
    id: number;
    name: string;
    img_path: string;
    is_active: boolean;
    listWinners?: SingleWinInfo[];
}

interface ApiResponse {
    data: BeltData;
}

const HallOfFameContainer = styled.div`
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
`;

const BeltHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    padding: 10px;
    background-color: ${colors.bgColorBlack2};
    border: 2px solid ${colors.bgColorBordeaux};
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);

    img {
        max-width: 40%;
        max-height: 80%;
        object-fit: contain;
    }

    .belt-info {
        h1 {
            color: white;
        }
    }

    .belt-status {
        color: white;
        text-align: center;
        margin-top: 5px;
    }
`;

const ChampionsList = styled.div`
    display: grid;
    gap: 5px;
`;

const ChampionCard = styled.div`
    background-color: ${colors.bgColorBordeaux};
    border: 4px solid ${colors.bgColorBlack2};
    color: white;
    border-radius: 8px;
    box-shadow: 5px 2px 4px rgba(0,0,0,0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 150px;

    .champion-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex: 1;
        width: 25%;

        img {
            width: 75px;
            height: 75px;
            object-fit: cover;
            border: 2px solid white;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                border: 4px solid white;
                transform: scale(1.1);
            }
        }

        .wrestler-details {
            text-align: center;
            h3 {
                margin: 0;
                font-size: 16px;
                font-weight: 500;
            }
        }
    }

    .win-date {
        font-size: 1.1rem;
        margin: 0;
        text-align: center;
        padding: 0 1rem;
        text-align: center;
        width: 50%;
    }

    .ppv-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 25%;
        height: 100%;

        .ppv-name {
            font-weight: 600;
            font-size: 18px;
            text-align: center;
            margin: 0;
        }

        .ppv-image {
            width: 75px;
            max-height: 70%;
            border-radius: 4px;
            object-fit: cover;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                border: 4px solid white;
                transform: scale(1.1);
            }
        }
    }
`;

const TagBeltInfoDesktop: FC = () => {
    const responseData = (useLoaderData() as ApiResponse)['data'];
    const beltData = responseData;
    const navigate = useNavigate();

    const navigateToWrestler = (wrestler: Winner): void => {
        const wrestlerId = wrestler.id;
        const wrestlerName = wrestler.name;
        navigate(`/wrestlers/i_${wrestlerId}_d_${wrestlerName}`);
    };

    const navigateToPpv = (ppvId: number, ppvName: string): void => {
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    };

    return (
        <CommonWrapper>
            <MainContainer>
                <HallOfFameContainer>
                    <BeltHeader className="belt-header">
                        <div className="belt-info">
                            <h1 className="belt-name">{beltData.name}</h1>
                        </div>
                        <img
                            src={process.env.REACT_APP_STORAGE_URL + beltData.img_path}
                            alt={beltData.name}
                        />
                        <p className="belt-status">Stato: {beltData.is_active ? 'Attiva' : 'Ritirata'}</p>
                    </BeltHeader>

                    <ChampionsList className="champions-list">
                        {beltData.listWinners && beltData.listWinners.map((infoSingleWin, index) => (
                            <ChampionCard
                                key={index}
                                onClick={() => {
                                    if (infoSingleWin.ppv_name.toLowerCase() !== 'fear' && infoSingleWin.ppv_name.toLowerCase() !== 'tap out' && infoSingleWin.ppv_name.toLowerCase() !== 'lite') {
                                        navigateToPpv(infoSingleWin.ppv_id, infoSingleWin.ppv_name);
                                    }
                                }}
                            >
                                <div className="champion-info">
                                    {infoSingleWin.winners.map((winner, winnerIndex) => (
                                        <div key={winnerIndex} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 5px' }}>
                                            {winner.avatar_path ? (
                                                <img
                                                    src={process.env.REACT_APP_STORAGE_URL + winner.avatar_path}
                                                    alt={winner.name}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigateToWrestler(winner);
                                                    }}
                                                />
                                            ) : (
                                                <div style={{ width: '75px', height: '75px', border: '2px solid white', backgroundColor: '#333' }} />
                                            )}
                                            <div className="wrestler-details">
                                                <h3>{winner.name ? winner.name : 'VACANTE'}</h3>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <p className="win-date">{infoSingleWin.date_win}</p>
                                <div className="ppv-info">
                                    <p className="ppv-name">{infoSingleWin.ppv_name}</p>
                                    {infoSingleWin.ppv_img_path &&
                                        <img
                                            src={process.env.REACT_APP_STORAGE_URL + infoSingleWin.ppv_img_path}
                                            alt={infoSingleWin.ppv_name}
                                            className="ppv-image"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigateToPpv(infoSingleWin.ppv_id, infoSingleWin.ppv_name);
                                            }}
                                        />
                                    }
                                </div>
                            </ChampionCard>
                        ))}
                    </ChampionsList>
                </HallOfFameContainer>
            </MainContainer>
        </CommonWrapper>
    );
};

export default TagBeltInfoDesktop;
